export function formatToStringTime(timestamp: number): string {
  const date = new Date(timestamp * 1000);
  return date.getHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes();
}

export function toFormatDate(date: string | null): string {
  if (!date || date === 'NA') {
    return '';
  }
  //@TOOD: add try catch if invalid date
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });
}

export function toFormatDateTime(date: string | null): string {
  if (!date) {
    return '';
  }
  //@TOOD: add try catch if invalid date
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });
}
